import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, IconSvg, Modal } from '@/lib/v2/components';
import { Flex } from '@/lib/v2/components/Layout/Stack';
import { Text } from '@/lib/v2/components/Text';
import { CheckBadgeIcon } from '@/lib/v2/icons/outline';

interface ImportSuccessModalProps {
  showModalSuccess: boolean;
  setShowModalSuccess: Dispatch<SetStateAction<boolean>>;
}

export const ImportSuccessModal = ({
  showModalSuccess,
  setShowModalSuccess,
}: ImportSuccessModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleGoToPage = (pageName: string) => navigate({ pathname: `/v2/${pageName}` });

  return (
    <Modal open={showModalSuccess} onClose={() => setShowModalSuccess(false)}>
      <Flex column noGrow alignment="center" textAlignment="center">
        <IconSvg height="64px" svgComponent={<CheckBadgeIcon />} width="64px" />
        <Text
          alignment="center"
          className="mt-3 !text-18 text-[#01263F]"
          fontWeight="medium"
          variant="headline"
        >
          {t('IMPORT_MAIN.contactAdded')}
        </Text>
        <Text className="text-[#01263F]" variant="text">
          {t('IMPORT_MAIN.sendMessage')}
        </Text>
      </Flex>
      <div className="mt-8">
        <Flex withGap alignment="center" gapSize="small">
          <Button
            fullWidth
            outline
            primary
            id="modal-goToContactsBtn"
            size="large"
            onClick={() => handleGoToPage('contacts')}
          >
            {t('IMPORT_MAIN.goToContacts')}
          </Button>
          <Button
            fullWidth
            id="modal-goToCampaignsBtn"
            size="large"
            onClick={() => handleGoToPage('campaigns')}
          >
            {t('IMPORT_MAIN.goToCampaign')}
          </Button>
        </Flex>
      </div>
    </Modal>
  );
};
